export const LogoMark = ({ className = "h-8 w-auto" }) => (
  <svg viewBox="0 0 64 32" fill="none" className={className} aria-hidden="true">
    <rect x="1" y="9" width="4" height="14" rx="1" fill="currentColor" />
    <rect x="7" y="5" width="5" height="22" rx="1" fill="currentColor" />
    <rect x="52" y="5" width="5" height="22" rx="1" fill="currentColor" />
    <rect x="59" y="9" width="4" height="14" rx="1" fill="currentColor" />
    <path
      d="M12 16h9l6-10 9 20 6-10h10"
      stroke="#2D9CDB"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Logo = ({ compact = false }) => (
  <span className="flex items-center gap-2.5 text-white">
    <LogoMark className={compact ? "h-7 w-auto" : "h-8 w-auto"} />
    <span className="leading-none">
      <span className="block font-display text-xl font-extrabold uppercase tracking-wide">
        Lift Edge
      </span>
      <span className="block font-mono text-[9px] uppercase tracking-[0.28em] text-ash">
        Hercules Fitness Store
      </span>
    </span>
  </span>
);
